module.exports = __webpack_public_path__ + "static/media/parallax1_desktop.9461ae7a.png";